import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedReorder202510: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_reorder_202510",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-10-01",
  endDate: "2025-10-31",
  impressions: 4765,
  clicks: 105,
  adsSpendDollars: 247,
  budgetDollars: 600,
  salesDollars: 2700,
  bestEstimateRoas: 10.93,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.41,
  reorderConversions: 8,
  dataAvailableAtDate: "2025-11-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
